<nav class="navbar fixed-top navbar-expand-lg navbar-dark mb-3">
  <a class="navbar-brand" [routerLink]="'/'">
    <!--<strong>Cocina</strong> sin recetas&nbsp;&nbsp;<i class="fa fa-lemon-o"></i>-->
    <img src="../../../assets/img/cookadhoc-horizontal.png" alt="CookAdHoc">
  </a>
  <button
    class="navbar-toggler"
    type="button"
    (click)="isMenuCollapsed = !isMenuCollapsed"
  >
    &#9776;
  </button>

  <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse">
    <ul class="navbar-nav">
      <app-nav-elements (click)="isMenuCollapsed = true"></app-nav-elements>
    </ul>
  </div>
</nav>
